import { type ComboboxItemWithFormatted, SelectMultiple } from '@/common/components';
import { McpConnectionStatus } from '@/common/graphql';

import { McpConnectionStatusBadge, McpConnectionStatusLabels } from './McpConnectionStatusBadge';

const STATUS_OPTIONS: ComboboxItemWithFormatted<McpConnectionStatus>[] = [
  McpConnectionStatus.Active,
  McpConnectionStatus.Expired,
  McpConnectionStatus.Revoked,
].map(
  status =>
    ({
      value: status,
      label: McpConnectionStatusLabels[status],
      labelFormatted: <McpConnectionStatusBadge status={status} />,
    }) as ComboboxItemWithFormatted<McpConnectionStatus>,
);

interface McpConnectionStatusSelectProps {
  value: McpConnectionStatus[] | null;
  onChange: (statuses: McpConnectionStatus[]) => void;
}

export const McpConnectionStatusSelect = ({ value, onChange }: McpConnectionStatusSelectProps) => (
  <SelectMultiple<ComboboxItemWithFormatted<McpConnectionStatus>, McpConnectionStatus>
    data={STATUS_OPTIONS}
    loading={false}
    multipleSelectedLabel={(_, labels) => labels.join(', ')}
    placeholder="Status"
    searchable={false}
    value={value}
    onChange={items => onChange(items.map(item => item.value))}
  />
);
